import { FC, ReactNode, useState } from 'react';
import AiContentLimitReachedModal from 'app/modules/aiContent/components/AiContentLimitReachedModal';
import { AiUsageLimitModalContext } from 'app/modules/aiContent/components/AiUsageLimitModalContext';

export const AiUsageLimitModalProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AiUsageLimitModalContext.Provider
      value={{ openLimitModal: () => setIsOpen(true) }}
    >
      {children}
      {isOpen && (
        <AiContentLimitReachedModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </AiUsageLimitModalContext.Provider>
  );
};
